import * as _ from 'lodash'
import {WB_CustomerRow, WB_PlanProductGroupRow, WB_ProductGroupRow, WB_TagRow} from "../PA.Core/PAdbSchemaRows";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {IHaveTags} from "../PA.Core/PA.Core.IF.Aspects";
import {IHaveEvents} from "../PA.TPM.Core/PA.TPM.IF.Aspects";
import {EventBO} from "../PA.TPM.BusinessObjects/EventBO";
import {IEventCollectionContext} from "./PA.UIM.TPM.IF"
import {TagBag} from "../PA.Utils/TagBag";
import {Subscription} from "rxjs/Subscription";
import {CollectionUtils} from "../PA.Core/Basic/Collections"
import {ASync} from "../PA.Core/Basic/ASync";
import {PlanBO} from "../PA.TPM.BusinessObjects/PlanBO";
import {IProgressProvider} from "../PA.Core/PA.Core.IF.Basic";
import {ProgressProvider} from "../PA.Core/Basic/Progress";

export interface IEventCollectionContextCreateOptions {
}

export class EventCollectionContext
  implements IEventCollectionContext
{

  private _IHaveEvents: IHaveEvents = undefined
  private _IHaveEventsChanged: BehaviorSubject<IEventCollectionContext>
  private _LoadProgressProvider: ProgressProvider
  private _sourceCustomers_All: WB_CustomerRow[] = []
  private _sourceCustomers_Selected: WB_CustomerRow[] = []

  private _productGroups_Selected: WB_ProductGroupRow[] = []
  private _tags_IHaveTags: IHaveTags = undefined
  private _selectedChanged: BehaviorSubject<IEventCollectionContext>;

  private _filteredEvents: EventBO[] = []
  private _filteredEventsChanged: BehaviorSubject<IEventCollectionContext>;

  // Subscriptions
  //    IHaveEvents Changed
  //    dct IEventBoundsChanged
  private _EventsChangedSubscription: Subscription
  private _dctBoundsChangedSubscriptionByEventId: {[id: number]: Subscription}
  private _dctPlansLoadedById: {[id: number]: PlanBO}

  constructor(option?: IEventCollectionContextCreateOptions) {
    this._IHaveEvents = undefined
    this._IHaveEventsChanged = new BehaviorSubject<IEventCollectionContext>(this)
    this._selectedChanged = new BehaviorSubject<IEventCollectionContext>(this)
    this._LoadProgressProvider = new ProgressProvider()

    this._filteredEvents = []
    this._filteredEventsChanged = new BehaviorSubject<IEventCollectionContext>(this)
    this._EventsChangedSubscription = undefined
    this._dctBoundsChangedSubscriptionByEventId = {}
    this._dctPlansLoadedById = {}
    this._tags_IHaveTags = new TagBag()
    this._tags_IHaveTags.TagsChanged.subscribe(this.Tags_OnChanged.bind(this))

  }

  get EventCollection(): IHaveEvents {
    return this._IHaveEvents
  }


  Register(anIHaveEvents: IHaveEvents): void {
    var self = this

    if (_.isEmpty(anIHaveEvents)) {
      this.UnRegister()
      return
    }

    self._IHaveEvents = anIHaveEvents

    anIHaveEvents.EventLoadProgressProvider.addListener(self.LoadProgressProvider)

    var loadPromise: Promise<any>
    if (anIHaveEvents.OnIHaveEventsLoaded) {
      loadPromise = Promise.resolve(anIHaveEvents)
    } else {
      loadPromise = anIHaveEvents.OnIHaveEventsLoaded
    }

    loadPromise
      .then((anIHaveEvents: IHaveEvents) => {
        //

        if (self._IHaveEvents === anIHaveEvents) {
          // Complete Registration after it's loaded
          self._EventsChangedSubscription =  self._IHaveEvents.EventsChanged.subscribe(self.Internal_IHaveEventsEventsChanged.bind(self))
          self.SyncPlanRegistration()
          self.SyncEventRegistration()
        }

      }).catch((err) => {
      return
    })

  }

  private SyncEventRegistration(): void {
    var self = this
    _.forEach(self._IHaveEvents.Events, (anEvtBO: EventBO) => {
      self.RegisterEvent(anEvtBO)
    })
  }

  private RegisterEvent(anEventBO: EventBO): void {
    var self = this

    if(_.isEmpty(anEventBO)){
      return
    }

    if (!(anEventBO.drWB_Event.cif.WB_EVT_ID in self._dctBoundsChangedSubscriptionByEventId)) {
      self._dctBoundsChangedSubscriptionByEventId[anEventBO.drWB_Event.cif.WB_EVT_ID] = anEventBO.ExecutionBoundsChanged.subscribe(self.OnEventBoundsChanged.bind(self))
    }

  }

  private OnEventBoundsChanged(anEvtBO: EventBO) {
    // redraw.. Events Changed
    this.notifyEventsChanges()
    this.ReFilterEvents()
  }

  private Internal_IHaveEventsEventsChanged() {
    this.SyncPlanRegistration()
    this.SyncEventRegistration()
    this.notifyEventsChanges()
    this.ReFilterEvents()
  }

  UnRegister(): void {

    if (this._IHaveEvents){
      this._IHaveEvents.EventLoadProgressProvider.removeListener(this.LoadProgressProvider)
    }

    this._IHaveEvents = undefined

    if(!_.isEmpty(this._EventsChangedSubscription)){
      this._EventsChangedSubscription.unsubscribe()
      this._EventsChangedSubscription = undefined
    }

    _.forEach(this._dctBoundsChangedSubscriptionByEventId, (subscr: Subscription, key) => {

      if(!_.isEmpty(subscr)) {
        subscr.unsubscribe()
      }
    })
    this._dctBoundsChangedSubscriptionByEventId = {}

    //  Empty Filtered List
    this._filteredEvents = []
    this._filteredEventsChanged.next(this)

  }

  private async SyncPlanRegistration(){
    const self = this

    let arrSourceCustomers: WB_CustomerRow[] = []

    let arrPlansBOs = this._IHaveEvents.Plans
    for(var idx in arrPlansBOs) {

      let aPlanBO = arrPlansBOs[idx]
      if(aPlanBO.drWB_Plan.cif.WB_PLAN_ID in self._dctPlansLoadedById) {
        // Do nothing
      } else {
        self._dctPlansLoadedById[aPlanBO.drWB_Plan.cif.WB_PLAN_ID] = aPlanBO
      }

      let loadPromise: Promise<any>
      if (aPlanBO.bIHaveProductGroupsLoaded) {
        loadPromise = ASync.resolve(aPlanBO)
      } else {
        loadPromise = aPlanBO.OnIHaveProductGroupsLoaded
      }
      await loadPromise

      if (aPlanBO.bIHaveSourceCustomersLoaded) {
        loadPromise = ASync.resolve(aPlanBO)
      } else {
        loadPromise = aPlanBO.OnIHaveSourceCustomersLoaded
      }
      await  loadPromise
      CollectionUtils.addDistinctByKey(arrSourceCustomers, aPlanBO.SourceCustomers, 'WB_CUST_ID')
    }

    CollectionUtils.sync(self._sourceCustomers_All, arrSourceCustomers)
    self.notifyEventsChanges()

  }

  get AllPlans(): PlanBO[] {
    if(_.isEmpty(this._IHaveEvents)) {
      return []
    }

    if(!this._IHaveEvents.OnIHaveEventsLoaded) {
      return []
    }

    return this._IHaveEvents.Plans
  }

  get AllEvents(): EventBO[] {

    if(_.isEmpty(this._IHaveEvents)) {
      return []
    }

    if(!this._IHaveEvents.OnIHaveEventsLoaded) {
      return []
    }

    return this._IHaveEvents.Events

  }

  get IHaveEventsChanged(): BehaviorSubject<IEventCollectionContext> { return this._IHaveEventsChanged }


  get LoadProgressProvider(): IProgressProvider { return this._LoadProgressProvider }

  get SourceCustomers_All(): WB_CustomerRow[] { return this._sourceCustomers_All }
  get SourceCustomers_Selected(): WB_CustomerRow[]  { return this._sourceCustomers_Selected }
  set SourceCustomers_Selected(arrWBCusts: WB_CustomerRow[]) {
    if(!_.isArray(arrWBCusts)) return

    // Sync, raise changed selected changed event, then set filtered events
    CollectionUtils.sync(this._sourceCustomers_Selected, arrWBCusts)

    this.notifySelectionChanged()
    this.ReFilterEvents()
  }

  get ProductGroups_All(): WB_ProductGroupRow[] {
    if(_.isEmpty(this._IHaveEvents)){
      return []
    }

    // Iterate Over Plans to get fill list of Product Groups
    if(this._IHaveEvents.getProductGroupAll(true)){
      let dctWBProductGroups: {[id:number]: WB_ProductGroupRow} = {}

      _.forEach(this._IHaveEvents.getPlanBOs(true), (aPlanBO: PlanBO) => {
          _.forEach(aPlanBO.WB_Plan.WB_Plan_ProductGroupRows, (aPlnPG: WB_PlanProductGroupRow) => {
            if(aPlnPG && aPlnPG.WB_ProductGroupRow){
              if(!(aPlnPG.WB_ProductGroupRow.cif.WB_PRDGRP_ID in dctWBProductGroups)){
                dctWBProductGroups[aPlnPG.WB_ProductGroupRow.cif.WB_PRDGRP_ID] = aPlnPG.WB_ProductGroupRow
              }
            }
          })
      })

      return _.values(dctWBProductGroups);
    }

    // Return only the Selected Product Groups
    return this._IHaveEvents.getProductGroups(true)
  }
  get ProductGroups_Selected(): WB_ProductGroupRow[] { return this._productGroups_Selected }
  set ProductGroups_Selected(arrWBPrdGrps: WB_ProductGroupRow[]) {
    if(!_.isArray(arrWBPrdGrps)) return

    // Sync, raise changed selected changed event, then set filtered events
    CollectionUtils.sync(this._productGroups_Selected, arrWBPrdGrps)

    this.notifySelectionChanged()
    this.ReFilterEvents()
  }


  get Tags_All(): WB_TagRow[] { return this._tags_IHaveTags.AllTags}
  get Tags_Selected(): WB_TagRow[] { return this._tags_IHaveTags.Tags}
  get Tags_IHaveTags(): IHaveTags { return this._tags_IHaveTags}

  Tags_OnChanged(): void {

    this.notifySelectionChanged()
    this.ReFilterEvents()
  }


  get SelectionChanged(): BehaviorSubject<IEventCollectionContext> { return this._selectedChanged }
  get FilteredEvents(): EventBO[] { return this._filteredEvents }
  get FilteredEventsChanged(): BehaviorSubject<IEventCollectionContext> { return this._filteredEventsChanged }

  private ReFilterEvents(){
    var self = this
    if (_.isEmpty(self._IHaveEvents)){
      self._filteredEvents.length = 0
      self.notifyFilteredEventsChanged()
      return
    }

    // Iterate over events, see if the Event belongs in the collection
    let arrEventBOsInScope: EventBO[] = []

    _.forEach(self.AllEvents, (anEventBO: EventBO) => {

      if(anEventBO.bIsDeleted){
        return;
      }

      let bHasSourceCustomer = true
      let bHasProductGroup = true
      let bHasTag = true

      var found = false

      // Check Source Customer
      if((anEventBO.SourceCustomers.length > 0) && (self._sourceCustomers_Selected.length > 0)){
        // Check for Any existing
        _.forEach(self._sourceCustomers_Selected, (aSourceCustomer: WB_CustomerRow) => {
          if(anEventBO.hasSourceCustomer(aSourceCustomer.cif.WB_CUST_ID)){
            found = true
            return false // stop iterating
          }
        })
        bHasSourceCustomer = found
      }
      if(!bHasSourceCustomer) { return } // next event

      // Check Product Groups
      found = false
      if((self._productGroups_Selected.length > 0)){
        // Check for Any existing
        _.forEach(self._productGroups_Selected, (aPrdGrpRow: WB_ProductGroupRow) => {
          if(anEventBO.hasProductGroup(aPrdGrpRow.cif.WB_PRDGRP_ID)){
            found = true
            return false // stop iterating
          }
        })
        bHasProductGroup = found
      }
      if(!bHasProductGroup) { return } // next event

      // Check Tags
      found = false
      if(self.Tags_IHaveTags.Tags.length > 0) {
        // Iterate over selected Tags.. to see if exists..
        _.forEach(self.Tags_IHaveTags.Tags, (aTag: WB_TagRow) => {
          if(anEventBO.hasTag(aTag.cif.WB_TAG_ID)){
            found = true
            return false // stop iterating
          }
        })
        bHasTag = found
      }
      if(!bHasTag) { return } // next event

      arrEventBOsInScope.push(anEventBO)

  })

    CollectionUtils.sync(self._filteredEvents, arrEventBOsInScope)
    self.notifyFilteredEventsChanged()

  }

  private notifySelectionChanged() {
    this._selectedChanged.next(this)
  }

  private notifyFilteredEventsChanged() {
    this._filteredEventsChanged.next(this)
  }

  private notifyEventsChanges() {
    this._IHaveEventsChanged.next(this)
  }

}

